<template>
  <v-app id="inspire">

    <v-app-bar app color="blue-grey lighten-2" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Paragon DZ</v-toolbar-title>
      <v-spacer></v-spacer>



      <v-toolbar-items class="upper-corner">

        <v-avatar color="indigo" size="36">
          <span class="white--text text-h6">{{ getInitials(this.user.name) }}</span>
        </v-avatar>

        <v-divider vertical></v-divider>

        <v-btn icon @click.prevent="logout">
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>


      </v-toolbar-items>

      </v-toolbar>


    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>

      <v-btn block to="/home" v-if="inSettings">
        <v-icon>mdi-keyboard-backspace</v-icon> &nbsp; Back
      </v-btn>

      <NavBar v-if="inSettings" :navLinks="SettingsNavLinks" />

      <NavBar v-else :navLinks="MainNavLinks" />

      <template v-if="!inSettings && checkGate('settings-access')" v-slot:append>
        <div class="pa-2">
          <v-btn block to="/settings">
            <v-icon>mdi-cog-outline</v-icon> &nbsp; Settings
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>


    <v-main>
      <v-container fluid>
        <v-row>
          <v-col>
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer color="blue-grey lighten-2" app>
      <span class="white--text">&copy; 2021</span>
    </v-footer>
  </v-app>
</template>

<script>
//import { mapActions, mapState, mapGetters } from 'vuex'
import NavBar from './NavBar.vue'



export default {

  components: {
    NavBar
  },

  props: ['source', 'user', 'roles'],

  data: () => ({

    drawer: true,


    MainNavLinks: [
      {

        title: 'Check in',
        icon: 'mdi-airport',
        path: { name: 'check-in' },
        gate: 'checkin-access',

      },

      {

        title: 'Manifest',
        icon: 'mdi-airplane',
        path: { name: 'manifest' },
        gate: 'manifest-access',
      },

      {

        title: 'Jumps',
        icon: 'mdi-parachute',
        path: { name: 'jumps' },
        gate: 'checkin-access',
      },

      {

        title: 'Daily Report',
        icon: 'mdi-clipboard-text-outline',
        path: { name: 'dailyreport' },
      },

      {

        title: 'Transactions',
        icon: 'mdi-currency-usd',
        path: { name: 'transactions' },
        gate: 'sales-access',
      },

      {

        title: 'Gear Tracking',
        icon: 'mdi-folder-cog-outline',
        path: { name: 'rigs' },
        gate: 'gear-tracking-access',
      },


      {

        title: 'Reports',
        icon: 'mdi-chart-box',


        children: [

          {
            title: 'Wages',
            //icon: 'perm_data_setting',
            path: { name: 'wages' },
            gate: 'view-reports',

          },
          {
            title: 'Totals by Person',
            //icon: 'perm_data_setting',
            path: { name: 'rangereport' },
            gate: 'users-mgmt',

          },
          {
            title: 'DropZone Overview',
            //icon: 'group',
            path: { name: 'dailyreportrange' },
            gate: 'view-reports',

          },
          {
            title: 'Package Sales',
            //icon: 'person',
            path: { name: 'pckgsales' },
            gate: 'sales-access'
          },
          {
            title: 'Rig Components Log',
            //icon: 'person',
            path: { name: 'componentslog' },
            gate: 'gear-tracking-access'
          },
          {
            title: 'Purchases',
            //icon: 'person',
            path: { name: 'resourceslog' },
            gate: 'sales-access'
          }
        ]
      },

      {

        title: 'Search',
        icon: 'mdi-magnify',
        path: { name: 'jumps-search' },
        gate: 'checkin-access',

      },

    ],


    SettingsNavLinks: [
      {

        title: 'Check in',
        icon: 'mdi-airport',
        // path: { name : 'check-in' },
        gate: 'checkin-access',

        children: [

          {
            title: 'Packages',
            //icon: 'person',
            path: { name: 'products' },
            gate: 'checkin-access',
          },
          {
            title: 'Agents',
            //icon: 'person',
            path: { name: 'agents' },
            gate: 'checkin-access',
          },
          {
            title: 'Addons',
            //icon: 'person',
            path: { name: 'addons' },
            gate: 'checkin-access',
          },
          {
            title: 'Merch Stock',
            //icon: 'person',
            path: { name: 'merch' },
            gate: 'checkin-access',
          }

        ]

      },

      {

        title: 'Manifest',
        icon: 'mdi-airplane',
        // path: { name : 'check-in' },
        gate: 'manifest-access',

        children: [

          {
            title: 'Instructors',
            //icon: 'person',
            path: { name: 'instructors' },
            gate: 'manifest-access',
          },
          {
            title: 'Pilots',
            //icon: 'person',
            path: { name: 'pilots' },
            gate: 'manifest-access',
          },
          {
            title: 'Packers',
            //icon: 'person',
            path: { name: 'packers' },
            gate: 'manifest-access',
          },
          {
            title: 'Aircrafts',
            //icon: 'person',
            path: { name: 'aircrafts' },
            gate: 'manifest-access',
          },
          {
            title: 'Resources',
            //icon: 'person',
            path: { name: 'resources' },
            gate: 'manifest-access',
          },



        ]

      },

      {
        title: 'Users Management',
        icon: 'mdi-account-group',
        // path: { name : 'check-in' },
        gate: 'users-mgmt',

        children: [
          {
            title: 'Users',
            path: { name: 'users' },
            gate: 'users-mgmt',
          },
          {
            title: 'Roles',
            path: { name: 'roles' },
            gate: 'users-mgmt',
          },
          {
            title: 'Tasks',
            path: { name: 'tasks' },
            gate: 'users-mgmt',
          },
        ]

      }
    ]


  }),


  computed: {
    inSettings() {
      return this.$route.matched.some(({ name }) => name === 'settings')
    }
  },



  created() {
    this.$store.state.user = this.user
    this.$store.state.uuid = "5f7f5299-b4a9-4995-9b25-531a402e32f8"
    this.$store.state.user.roles = this.roles


    if (this.$store.state.products.length == 0)
      this.$store.dispatch('fetchProducts')


  },

  methods: {

    logout() {
      axios
        .request({ baseURL: '/', url: 'logout', method: 'post' })
        .then(() => location.assign('/'))
    },

  },


}
</script>